import React from 'react';
import PageHeader from 'components/PageHeader/PageHeader';
import { Button, Icon, IconList } from 'components/core';
import { Inline } from 'components/layout';
import {
  REVIEW_DETAILS,
  REVIEW_EXPORT,
  REVIEW_PRISMA,
  tokenizeRoute,
} from 'query/routes';
import { getReviewId } from 'query/review';

type Props = {
  backLink: string;
};

const SummaryPageHeader = ({ backLink }: Props) => {
  const reviewId = getReviewId();

  const rightContent = () => {
    return (
      <Inline spacing={2}>
        <Button
          size="md"
          variant="outline"
          to={tokenizeRoute(REVIEW_DETAILS, {
            review_id: reviewId,
          })}
        >
          <Icon icon={IconList.solid.faGear} />
          Settings
        </Button>
        <Button
          size="md"
          variant="outline"
          to={tokenizeRoute(REVIEW_PRISMA, {
            review_id: reviewId,
          })}
        >
          <Icon icon={IconList.solid.faListAlt} />
          PRISMA
        </Button>
        <Button
          size="md"
          type="brand"
          variant="solid"
          to={tokenizeRoute(REVIEW_EXPORT, {
            review_id: reviewId,
          })}
        >
          <Icon icon={IconList.solid.faCloudDownload} />
          Export
        </Button>
      </Inline>
    );
  };

  return (
    <PageHeader
      headerText="Review Summary"
      backLink={backLink}
      rightContent={rightContent}
    />
  );
};

export default SummaryPageHeader;
